import { localStorageHelper } from '../../helpers/storage/index.js';
import { isLoggedIn } from '../../services/schibstedAccount.js';
import { getDaysDiff } from '../../utils/datetime.js';

const LOCAL_STORAGE_KEY = 'vgtv/autologin-timestamp';

function setLastShown(lastShown: number) {
  localStorageHelper.setItem(LOCAL_STORAGE_KEY, lastShown);
}

function getLastShown() {
  const lastShown = localStorageHelper.getItem(LOCAL_STORAGE_KEY);

  return lastShown !== null ? parseInt(lastShown, 10) : null;
}

async function shouldAttemptAutologin() {
  const loggedIn = await isLoggedIn();
  const lastShown = getLastShown();

  return (
    !loggedIn && (lastShown === null || getDaysDiff(lastShown, Date.now()) > 3)
  );
}

export { shouldAttemptAutologin, getLastShown, setLastShown };
